















































import { Component, Vue, Prop, Config, Watch } from "@/common";

@Component({})
export default class TwUpload extends Vue {
  @Prop({})
  private action!: string;

  @Prop({ default: () => {} })
  private data!: object;

  @Prop({ default: false })
  private multiple!: boolean;

  @Prop({ default: false })
  private drag!: boolean;

  @Prop({ default: true })
  private autoUpload!: boolean;

  @Prop({ default: false })
  private disabled!: boolean;

  @Prop({ default: false })
  private showMessage!: boolean;

  @Prop({ default: 10 })
  private limit!: number;

  @Prop({})
  private onPreview!: Function;

  @Prop({})
  private onRemove!: Function;

  @Prop({})
  private onSuccess!: Function;

  @Prop({})
  private onError!: Function;

  @Prop({})
  private onProgress!: Function;

  @Prop({})
  private onChange!: Function;

  @Prop({})
  private beforeUpload!: Function;

  @Prop({})
  private beforeRemove!: Function;

  @Prop({})
  private onExceed!: Function;

  @Prop({})
  private httpRequest!: Function;

  //e.g. .jpg, .png, .doc
  @Prop({})
  private accept!: string;

  private visible: boolean = false;

  private msgArray: Array<string> = [];

  private uploadId!: string;

  private get uploadData(): object {
    return Object.assign({}, this.data, {
      uploadId: this.uploadId
    });
  }

  private get url(): string {
    return `${Config.baseUrl}${this.action}${
      this.action.indexOf("?") > 0 ? "&" : "?"
    }access_token=${this.$auth.getToken()}`;
  }

  private startUpload(file) {
    if (this.beforeUpload) {
      if (!this.beforeUpload(file)) {
        return false;
      }
    }
    if (!this.visible && this.showMessage) {
      this.visible = true;
    }
    this.msgArray[0] = `<div>${new Date().toString()} >> 正在上传[${
      file.name
    }]   0%</div>`;
  }

  private progress(event, file, fileList) {
    if (this.onProgress) {
      this.onProgress(event, file, fileList);
    }
    this.$set(
      this.msgArray,
      0,
      `<div>${new Date().toString()} >> 正在上传[${
        file.name
      }]   ${event.percent.toFixed(2)}%</div>`
    );
  }

  private created() {
    this.uploadId = this.$utils.Guid();
    this.$signalr.on("signalr.reveive", data => {
      if (data.uploadId && data.uploadId === this.uploadId) {
        this.msgArray.push(`<div>${new Date().toString()} >> ${data.message}`);
        if (!this.showMessage) {
          console.log(data.message);
        }
        //0 进行中 1 成功导入 2 警告(不终止) 3 异常(终止)
        if (data.status === 1 || data.status === 3) {
        }
      }
    });
  }

  private updated() {
    // this.$nextTick(function() {
    //   var div = document.getElementById("msgContent") || new HTMLDivElement();
    //   div.scrollTop = div.scrollHeight;
    // });
  }

  @Watch("visible")
  private clearMessageBox(val) {
    if (!val) {
      this.msgArray.splice(0);
      this.$emit("close");
    } else {
      var div = document.getElementById("msgContent");
      if (div) {
        div.scrollTop = div.scrollHeight;
      }
    }
  }

  public clearFiles() {}

  public abort() {}
}
